export default __webpack_public_path__ + "static/logotype-dde962bfb3b20dcfe33671d93f7e0ef5.svg";